module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!!_vm.username) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.username) + ", you're registered. You have " + _vm._s(_vm.balance) + " REC.")]), _vm._v(" "), _c('p', [_vm._v("You currently have " + _vm._s(_vm.match[1]) + " karma. If you haven't already during this registration period, you can re-register to update your karma and claim the difference in new REC.")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("Register")])], 1) : (!!_vm.match) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.match[0]) + ", you will receive " + _vm._s(_vm.match[1]) + " REC Tokens upon registration.")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("Register")])], 1) : _c('div', [_c('p', [_vm._v(_vm._s(("Your Ethereum account (" + _vm.account + ") does not match any that were pre-registered.")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s("If you have not pre-registered you can do so ")), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.reddit.com/message/compose/?to=EthRegBot&message=!ethreg%200xANETHADDRESSHERE&subject=pre-register"
    }
  }, [_vm._v("here")]), _vm._v(_vm._s(" and then wait a short while for a new registration period to be voted open. Please ")), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.reddit.com/message/compose/?to=carlslarson&subject=recdao"
    }
  }, [_vm._v("dm u/carlslarson")]), _vm._v(_vm._s(" or see the ")), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.reddit.com/r/recdao/comments/83wdeq/faq/"
    }
  }, [_vm._v("FAQ")]), _vm._v(_vm._s(" with any questions."))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.lookup,
      "return-object": "",
      "label": "Find pre-registration account",
      "autocomplete": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.selected) ? _c('p', [_vm._v(_vm._s(((_vm.selected.text) + " pre-registered with the account: " + (_vm.selected.value))))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fea9b938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Register.vue
// module id = 266
// module chunks = 1